// extracted by mini-css-extract-plugin
module.exports = {"desc":"confirmModal_desc__Yw6DW","actions":"confirmModal_actions__bBwb5"};